import { api } from "./api";

/**
 * Fetch every page of a paginated list (Laravel paginator, resource
 * collection or {data} envelope). For screens that need the whole set —
 * org chart, calendars, the offline seed — where a single request with a
 * big per_page was silently capped by the server (audit HR-22, LG-F-32).
 */
export const MAX_PAGES = 50;

function rows<T>(payload: unknown): T[] {
  if (Array.isArray(payload)) return payload as T[];
  if (payload && typeof payload === "object") {
    const data = (payload as { data?: unknown }).data;
    if (Array.isArray(data)) return data as T[];
  }
  return [];
}

function lastPage(payload: unknown): number {
  if (!payload || typeof payload !== "object") return 1;
  const p = payload as { last_page?: unknown; meta?: { last_page?: unknown } };
  const n = typeof p.last_page === "number" ? p.last_page
    : typeof p.meta?.last_page === "number" ? p.meta.last_page : 1;
  return Math.max(1, n);
}

export async function fetchAllPages<T>(path: string): Promise<T[]> {
  const out: T[] = [];
  const sep = path.includes("?") ? "&" : "?";
  for (let page = 1; page <= MAX_PAGES; page++) {
    const payload = await api<unknown>(`${path}${sep}page=${page}`);
    const batch = rows<T>(payload);
    out.push(...batch);
    if (batch.length === 0 || page >= lastPage(payload)) break;
  }
  return out;
}
